import React, {useEffect} from 'react';
import {useSidebar} from '@src/components/shadcn/sidebar';
import {Link} from 'react-router-dom';
import EzManageNavLinkLogo from '@src/icons/EzManageNavLinkLogo';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBars, faXmarkLarge} from '@fortawesome/pro-light-svg-icons';
import cn from '@src/util/cnHelper';
import {NavItem} from './types';

const NavHeader = ({homeNavItem}: {homeNavItem: NavItem}) => {
  const {isMobile, openMobile, setOpenMobile} = useSidebar();
  useEffect(() => {
    if (isMobile) {
      setOpenMobile(false);
    }
  }, [isMobile, setOpenMobile]);

  const toggleMobileNavbar = () => {
    setOpenMobile(!openMobile);
  };
  return (
    <div
      className={cn(
        'absolute flex justify-between items-center inset-0 h-12 p-5',
        isMobile ? 'w-full' : 'w-[--sidebar-width]'
      )}
    >
      <Link className="flex justify-center items-center cursor-pointer" to={homeNavItem.to}>
        <EzManageNavLinkLogo />
      </Link>
      {isMobile && (
        <FontAwesomeIcon
          onClick={toggleMobileNavbar}
          className="cursor-pointer"
          icon={openMobile ? faXmarkLarge : faBars}
        />
      )}
    </div>
  );
};

export default NavHeader;
